module.exports = __webpack_public_path__ + "img/family_07_happy.ec501903.jpg";